import React from "react";
import { ErrorMessage, Field } from "formik";
import { Flex } from "../../../Flex";
import { FormInputErrorMessage } from "../../../FormInputErrorMessage";
import { FormikInputText } from "../../../FormikInputText";

interface Props {
  id: string;
}

export const DisconnectionDetailsHazards: React.FC<Props> = ({ id }) => {
  return (
    <Flex
      id={id}
      flexDirection="column"
      flexGrow={0.7}
      flexBasis={0}
      minWidth={["100%", "100%", "100%", 0]}
      mb={[4, 4, 4, 4]}
      mt={0}
    >
      <Field
        id={"disconnectionDetails.hazards"}
        name={"disconnectionDetails.hazards"}
        label="Are there any hazards to be aware of?"
        placeholder="e.g. asbestos"
        optional
        component={FormikInputText}
      />
      <ErrorMessage
        name="disconnectionDetails.hazards"
        className="field-error"
        component={FormInputErrorMessage}
      />
    </Flex>
  );
};
